export default {
  getDataCacheTableRow: (state) => state.dataCacheTableRows,
  getDataCacheErrTableRow: (state) => state.dataCacheErrRecordExcel,
  getDataFileNameExcel: (state) => state.dataCacheFileNameExxel
}
